import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import styleListData from "./ListAppealData.module.css";
import MainContent from "../../../layouts/maincontent/MainContent";
import Pagination, {
  PaginationTax,
} from "../../../shared/pagination/Pagination";
import SelectElement from "../../../shared/form/SelectElement";
import InputElement from "../../../shared/form/InputElement";
import { get_tax_appeals } from "../../../adapters/apis/taxAppeal/list";
import { getTaxAppealListFilterAllLookups } from "../../../adapters/apis/lookups/lookups";
import Moment from "moment";
import LoadingSpinner from "../../../components/Loading/LoadingSpinner";
import { DatePickerFormatedWithLimit } from "../../../shared/form/DatePickerFormated";
import disputePrint from "../../../assets/img/print.png";
import disputeInfo from "../../../assets/img/Icon feather-file-text.png";
import { useLocation } from "react-router-dom";

function ListAppealData() {
  const [appealTypes, setAppealTypes] = useState([]);
  const [taxAppealList, setTaxAppealList] = useState([]);
  const [appealLength, setAppealLength] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [startFrom, setStartFrom] = useState(1);
  const [active, setActive] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const [appealStatusTypes, setAppealStatusTypes] = useState([]);

  // const limit = 1;

  const [limit, setLimit] = useState(100);

  const initialFilters = {
    per_page: limit,
    request_number: "",
    appeal_type_id: "",
    from_date: "",
    to_date: "",
    status: "",
  };

  const [filters, setFilters] = useState({
    per_page: limit,
    request_number: "",
    appeal_type_id: "",
    from_date: "",
    to_date: "",
    status: "",
  });

  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const timer = setTimeout(() => {
      navigate({ state: null });
    }, 5000);

    return () => clearTimeout(timer); // Cleanup on unmount
  }, []);

  const [filtersErrors, setFiltersErrors] = useState({
    request_number: "",
    appeal_type_id: "",
    from_date: "",
    to_date: "",
    status: "",
  });

  const [success, setSuccess] = useState("");
  const [error, setError] = useState(null);

  const changeDataFormat = (filters) => {
    const data = {
      per_page: limit,
      request_number: filters?.request_number,
      appeal_type_id: filters?.appeal_type_id,
      from_date: filters?.from_date
        ? Moment(filters?.from_date).format("yyyy-MM-DD")
        : "",
      to_date: filters?.to_date
        ? Moment(filters?.to_date).format("yyyy-MM-DD")
        : "",
      status: filters?.status,
    };
    return data;
  };

  const handleLimitChange = (newLimit) => {
    setLimit(newLimit); // Update
    setCurrentPage(1); // Reset to first
    // callback(1); // Fetch data for page 1
  };

  useEffect(() => {
    getTaxAppealListFilterAllLookups().then((res) => {
      setAppealTypes(res?.data?.data?.appeal_types);
      setAppealStatusTypes(res?.data?.data?.appeal_status_types);
    });
  }, []);

  useEffect(() => {
    setIsLoading(true);

    get_tax_appeals(currentPage, changeDataFormat(filters))
      .then((res) => {
        setAppealLength(res?.data?.data?.meta?.total);
        setTaxAppealList(res?.data?.data?.data);
        setCurrentPage(res?.data?.data?.meta?.current_page);
        setStartFrom(res?.data?.data?.meta?.from);
        if (res?.data?.data?.data?.length === 0) {
          setError("لا توجد طلبات متاحة");
        }

        setIsLoading(false);
      })
      .catch((err) => {
        setError("لا توجد طلبات متاحة");
      });
  }, [active, limit]);

  function callback(active) {
    try {
      setIsLoading(true);
      setCurrentPage(active);
      get_tax_appeals(active, changeDataFormat(filters)).then((res) => {
        setAppealLength(res?.data?.data?.meta?.total);
        setTaxAppealList(res?.data?.data?.data);
        setStartFrom(res?.data?.data?.meta?.from);

        if (res?.data?.data?.data?.length === 0) {
          setError("لا توجد بيانات متاحة");
        }
        setIsLoading(false);
      });
    } catch (error) {
      setError("لا توجد بيانات متاحة");
    }
  }

  const handleFromDateChange = (parentCompenent, compenent, key, value) => {
    // If both from_date and to_date have values, clear to_date
    if (filters.from_date && filters.to_date) {
      setFilters((prev) => ({
        ...prev,
        to_date: "",
      }));
    }

    // Update the from_date field
    setFilters((prev) => ({
      ...prev,
      [key]: value,
      to_date: "",
    }));
  };

  const data = taxAppealList?.map((element, index) => {
    return (
      <tr key={element.id}>
        <td data-label="رقم الطلب">{element?.request_number}</td>
        <td data-label="نوع الطلب">
          {element?.appeal_type_text ? element?.appeal_type_text : ""}
        </td>
        <td data-label="حالة الطلب">
          {element?.status_text ? element?.status_text : ""}
        </td>
        <td data-label="تاريخ تقديم الطلب">{element?.created_at}</td>
        <td data-label="تفاصيل">
          <Link
            to={"/tax-appeal/details/" + element?.id}
            className={styleListData["btn-file"]}
            id="dispute_info_icon"
          >
            <img src={disputeInfo} className="img-fluid" />
          </Link>
        </td>
      </tr>
    );
  });

  const appealTypeOptions = appealTypes?.map((element) => {
    return (
      <option value={element.id} key={element.id}>
        {element?.name}
      </option>
    );
  });

  const appealStatusOptions = appealStatusTypes?.map((element) => {
    return (
      <option value={element.id} key={element.id}>
        {element?.name}
      </option>
    );
  });

  const search = () => {
    try {
      // setFlashMessage(false); // Clear the flash message
      setIsLoading(true);
      setCurrentPage(1);
      const formattedFilters = changeDataFormat(filters);
      // Call API with filters
      get_tax_appeals(1, formattedFilters).then((res) => {
        setAppealLength(res?.data?.data?.meta?.total);
        setTaxAppealList(res?.data?.data?.data);
        setCurrentPage(res?.data?.data?.meta?.current_page);
        setStartFrom(res?.data?.data?.meta?.from);
        if (res?.data?.data?.data?.length === 0) {
          setError("لا توجد بيانات متاحة");
        }
        setIsLoading(false);
      });
    } catch (error) {
      setError("لا توجد بيانات متاحة");
    }
  };

  const clear = () => {
    try {
      setFilters(initialFilters);
      setCurrentPage(1);
      setIsLoading(true);
      get_tax_appeals(1, initialFilters).then((res) => {
        setAppealLength(res?.data?.data?.meta?.total);
        setTaxAppealList(res?.data?.data?.data);
        setCurrentPage(res?.data?.data?.meta?.current_page);
        setStartFrom(res?.data?.data?.meta?.from);
        if (res?.data?.data?.data?.length === 0) {
          setError("لا توجد طلبات متاحة");
        }

        setIsLoading(false);
      });
    } catch (error) {
      setError("لا توجد طلبات متاحة");
    }
  };
  function changeFilters(parentCompenent, compenent, key, value) {
    setFilters((prev) => ({
      ...prev,
      [key]: value,
    }));
  }

  return (
    <MainContent>
      {isLoading ? (
        <LoadingSpinner />
      ) : (
        <>
          <section className={`${styleListData.listData}`}>
            <div className="container pt-4">
              <div className={styleListData.box}>
                <div className={`${styleListData["box-header"]}`}>
                  <h3 className={`${styleListData["box-title"]} mb-0`}>
                    الطعن الضريبى
                  </h3>
                  <div className={styleListData["btns-header"]}>
                    <Link
                      to="/tax-appeal/add"
                      className={styleListData["btns-header-order"]}
                      id="add_appeal_button"
                    >
                      تقديم طلب
                    </Link>
                  </div>
                </div>
                {location?.state?.message && (
                  <div className="alert alert-danger mt-2 text-center w-25 mx-auto">
                    <h3 className="fs-5">{location?.state?.message} </h3>
                  </div>
                )}

                <div className={`${styleListData["box-body"]}  mt-3`}>
                  <div className={`${styleListData["box-body-content"]}`}>
                    <div className="row align-items-center px-md-4">
                      <div className="col-12 col-sm-6 col-md-2 mb-4 flex-grow-1">
                        <InputElement
                          name="request_number"
                          mb4="mb-4"
                          labelHtmlFor="request_number"
                          labelClassName={`${styleListData["form-label"]} form-label`}
                          labelText="رقم الطلب"
                          inputType="text"
                          inputClassName="form-control"
                          inputID="request_number"
                          pClassName="text-danger mb-0 mt-2 me-2 fw-bolder"
                          value={filters.request_number}
                          onChange={changeFilters}
                          pText={filtersErrors.request_number}
                          maxLength="255"
                          placeholder="أدخل رقم الطلب"
                        />
                      </div>
                      <div className="col-12 col-sm-6 col-md-2 mb-4 flex-grow-1">
                        <SelectElement
                          mb4="mb-4"
                          labelHtmlFor="appeal_type_id"
                          labelClassName={`  form-label ${styleListData["form-label"]}`}
                          labelText="نوع الطلب"
                          selectClassName={`${styleListData["form-select"]} form-select`}
                          selectID="appeal_type_id"
                          name="appeal_type_id"
                          options={appealTypeOptions}
                          default="نوع الطلب"
                          pClassName="text-danger mb-0 mt-2 me-2 fw-bolder"
                          value={filters.appeal_type_id}
                          onChange={changeFilters}
                          pText={filtersErrors.appeal_type_id}
                          style={{ color: "#32A8ED" }}
                          placeholderText="نوع الطلب"
                        />
                      </div>
                      <div className="col-12 col-sm-6 col-md-2 mb-4 flex-grow-1">
                        <SelectElement
                          mb4="mb-4"
                          labelHtmlFor="status"
                          labelClassName={`  form-label  ${styleListData["form-label"]}`}
                          labelText="حالة الطلب"
                          selectClassName={`${styleListData["form-select"]} form-select`}
                          selectID="status"
                          name="status"
                          options={appealStatusOptions}
                          default="حالة الطلب"
                          pClassName="text-danger mb-0 mt-2 me-2 fw-bolder"
                          value={filters.status}
                          onChange={changeFilters}
                          pText={filtersErrors.status}
                          placeholderText="حالة الطلب"
                        />
                      </div>
                      <div className="col-12 col-sm-6 col-md-2 mb-4 flex-grow-1">
                        <DatePickerFormatedWithLimit
                          name="from_date"
                          name_datepicker="from_date"
                          mb4="mb-4"
                          labelHtmlFor="from_date"
                          labelClassName={`  ${styleListData["form-label"]} form-label`}
                          labelText="من تاريخ تقديم الطلب"
                          inputType="datePicker"
                          max={Moment().subtract(500, "years")}
                          min={Moment().subtract(18, "years")}
                          inputClassName="form-control"
                          inputID="to_dfrom_dateate"
                          pClassName="text-danger mb-0 mt-2 me-2 fw-bolder"
                          pText={filtersErrors.from_date}
                          value={filters.from_date}
                          placeholderText="من تاريخ تقديم الطلب"
                          onChange={handleFromDateChange}
                        />
                      </div>
                      <div className="col-12 col-sm-6 col-md-2 mb-4 flex-grow-1">
                        <DatePickerFormatedWithLimit
                          name="to_date"
                          name_datepicker="to_date"
                          mb4="mb-4"
                          labelHtmlFor="to_date"
                          labelClassName={`  ${styleListData["form-label"]} form-label`}
                          labelText="إلى تاريخ تقديم الطلب"
                          inputType="datePicker"
                          // max={Moment().subtract(500, "years")}
                          // min={Moment().subtract(18, "years")}
                          inputClassName={`${styleListData["form-control"]} form-control`}
                          inputID="to_date"
                          pClassName="text-danger mb-0 mt-2 me-2 fw-bolder"
                          pText={filtersErrors.to_date}
                          value={filters.to_date}
                          valueDate={filters.to_date}
                          onChange={changeFilters}
                          minDate={filters.from_date}
                          placeholderText="إلى تاريخ تقديم الطلب"
                        />
                      </div>
                    </div>
                    <div className="d-flex justify-content-end p-3">
                      <button
                        className={styleListData["btns-search"]}
                        onClick={search}
                        id="dispute_search_button"
                      >
                        بحث
                      </button>
                      <button
                        className={styleListData["btns-clear"]}
                        onClick={clear}
                        id="appeal_clear_button"
                      >
                        إعادة
                      </button>
                    </div>
                  </div>
                  <div
                    className={`${styleListData["table-responsive"]} table-responsive`}
                  >
                    <table className="table">
                      <thead>
                        <tr>
                          <th scope="col">رقم الطلب</th>
                          <th scope="col">نوع الطلب</th>
                          <th scope="col">حالة الطلب</th>
                          <th scope="col">تاريخ تقديم الطلب</th>
                          <th scope="col">تفاصيل</th>
                        </tr>
                      </thead>
                      <tbody>
                        {data?.length > 0 ? (
                          data
                        ) : (
                          <tr>
                            <td colSpan={6} className="h5 text-center">
                              {error}
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>
                  <PaginationTax
                    limit={limit}
                    count={appealLength}
                    active={currentPage}
                    callback={callback}
                    handleLimitChange={handleLimitChange}
                  />
                </div>
              </div>
            </div>
          </section>
        </>
      )}
    </MainContent>
  );
}

export default ListAppealData;
